import { render, staticRenderFns } from "./addNotaModal.vue?vue&type=template&id=2900e033"
import script from "./addNotaModal.vue?vue&type=script&lang=js"
export * from "./addNotaModal.vue?vue&type=script&lang=js"
import style0 from "./addNotaModal.vue?vue&type=style&index=0&id=2900e033&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports